import { render, staticRenderFns } from "./BlogButton.vue?vue&type=template&id=0d7b0992&scoped=true&"
import script from "./BlogButton.vue?vue&type=script&lang=js&"
export * from "./BlogButton.vue?vue&type=script&lang=js&"
import style0 from "./BlogButton.vue?vue&type=style&index=0&id=0d7b0992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b0992",
  null
  
)

export default component.exports